<template>
  <b-row>
    <b-col cols="12" lg="12" xl="12" class="mx-auto">
      <FileUploader
          :auto-redirect="true"
          redirect-route="apps-library-list"
          @upload-success="onUploadSuccess"
          @upload-error="onUploadError"
      />
    </b-col>
  </b-row>
</template>

<script>

import FileUploader from "@/views/components/Library/FileUploader.vue";
import {BCol, BRow,} from 'bootstrap-vue'

export default {
  name: 'UploadPage',
  components: {FileUploader, BRow, BCol},
  methods: {
    onUploadSuccess(data) {
      // optional: additional logic
      console.log('Upload success:', data)
    },
    onUploadError(error) {
      // optional: additional logic
      console.error('Upload error:', error)
    }
  }
}
</script>
